import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import StandardList from '../common/listing/list.component.jsx'
import {
    injectIntl,
    defineMessages,
    FormattedMessage
} from 'react-intl'
import Select from 'react-select';
import EmailNotificationAutomationComponent from './EmailNotificationAutomationComponent';


const messages = defineMessages({
    "triggersTitle": {
        id: "triggers.trigger_title",
        defaultMessage: "triggers"
    },
    "fully-invoiced-trigger": {
        id: "triggers.trigger_type.fully_invoice_trigger",
        defaultMessage: "When an order is complpetely invoiced",
    },
    "fully-received-trigger": {
        id: "triggers.trigger_type.fully_received_trigger",
        defaultMessage: "When all purchase orders ",
    },
    "change-status-command": {
        id: "triggers.command_type.change_order_status_command",
        defaultMessage: "Change order status to"
    },
    "notApplied": {
        id: "triggers.status_name.not_applied",
        defaultMessage: "- Not Applied -"
    },
    "inProgress": {
        id: "order.status.in_progress_label",
        defaultMessage: "In progress"
    },
    "completed": {
        id: "order.status.completed_label",
        defaultMessage: "Completed"
    }
})
const commandOrderStatus = "change-order-status-command"
const commandStatusNofification = "order-status-updated-notification-command"

const triggerableType = "order-status-automation"
const triggerKeys = {
    fullyReceivedTrigger: "fully-received-trigger",
    fullyInvoicedTrigger: "fully-invoiced-trigger",
    orderStatusNotificationTrigger: "order-status-notification-trigger",
}

const triggersList = [
    triggerKeys.fullyReceivedTrigger,
    triggerKeys.fullyInvoicedTrigger,
    triggerKeys.orderStatusNotificationTrigger
]

class OrderStatusTriggersList extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            triggers: {},
            triggersOrdUpdate: {},
            triggersHtml: [],
            triggersOrdUpdateHtml: [],
            loading: true,
        }
        this.onSelectChange = this.onSelectChange.bind(this)
        this.createTrigger = this.createTrigger.bind(this)
        this.saveTrigger = this.saveTrigger.bind(this)
        this.row = this.row.bind(this)
        this.createStatusesMap = this.createStatusesMap.bind(this)
    }

    componentDidMount() {
        this.fetchTriggers()
    }

    fetchTriggers() {
        this.setState({ loading: true })
        AppContext.getApiClient()
            .get('/triggerables/' + triggerableType).then(r => {
                var triggers = this.createTriggersMap(r.data)
                var triggersOrdUpdate = this.createTriggersOrdUpdateMap(r.data)
                var orderStatusesMap = this.createStatusesMap(this.props.orderStatuses)
                this.setState({
                    triggers: triggers,
                    triggersOrdUpdate: triggersOrdUpdate,
                    triggersHtml: Object.entries(triggers).map(([k, v]) => this.row(k, v, orderStatusesMap)),
                    triggersOrdUpdateHtml: Object.entries(triggers).map(([k, v]) => this.row(k, v, orderStatusesMap)),
                    loading: false,
                })
            })
    }

    createTrigger(triggerKey, newStatusId) {
        this.setState({ loading: true })
        AppContext.getApiClient()
            .post('/triggerables', {
                "commandKey": commandOrderStatus,
                "triggerKey": triggerKey,
                "triggerableType": triggerableType,
                "config": {
                    "newStatusId": newStatusId,
                }
            }).then((r) => {
                this.fetchTriggers()
            })
    }

    saveTrigger(trigger) {
        var isEnabled = trigger.attributes.isEnabled
        var newStatusId = trigger.attributes.config.newStatusId
        this.setState({ loading: true })
        AppContext.getApiClient()
            .patch(`/triggerables/${trigger.id}`, {
                "isEnabled": isEnabled,
                "config": {
                    "newStatusId": newStatusId,
                }
            }
            ).then(r => {
                this.fetchTriggers()
            })
    }

    createStatusesMap(orderStatuses) {
        return orderStatuses
            .filter(s => s.attributes.type === "completed" || s.attributes.type === "ordered")
            .reduce((map, key) => (map[key.id] = key, map), new Map())
    }

    createTriggersMap(accountTriggers) {
        var triggersMap = triggersList.filter(s => s !== triggerKeys.orderStatusNotificationTrigger).reduce((map, key) => (map[key] = {}, map), new Map())
        for (let trigger of accountTriggers) {
            if (trigger.attributes["triggerKey"] in triggersMap) {
                triggersMap[trigger.attributes["triggerKey"]] = trigger
            }
        }
        return triggersMap
    }

    createTriggersOrdUpdateMap(accountTriggers) {
        var triggersMap = triggersList.filter(s => s === triggerKeys.orderStatusNotificationTrigger).reduce((map, key) => (map[key] = {}, map), new Map())
        for (let trigger of accountTriggers) {
            if (trigger.attributes["triggerKey"] in triggersMap) {
                triggersMap[trigger.attributes["triggerKey"]] = trigger
            }
        }
        return triggersMap
    }

    onSelectChange(triggerKey) {
        return (event) => {
            let newStatusId = event.value
            var trigger = this.state.triggers[triggerKey]

            if (!trigger.id) {
                this.createTrigger(triggerKey, newStatusId)
            } else {
                if (newStatusId) {
                    trigger.attributes.isEnabled = true
                } else {
                    trigger.attributes.isEnabled = false
                }
                trigger.attributes.config.newStatusId = newStatusId
                this.saveTrigger(trigger)
            }
        }
    }


    row(key, trigger, statusesMap) {
        const orderedOptions = Object.values(statusesMap)
            .filter(status => status.attributes.type === 'ordered')
            .map(status => {
                return { label: status.attributes.name || 'Unnamed', value: status.id }
            })

        const completedOptions = Object.values(statusesMap)
            .filter(status => status.attributes.type === 'completed')
            .map(status => {
                return { label: status.attributes.name || 'Unnamed', value: status.id }
            })

        const options = [
            { label: <FormattedMessage id="triggers.status_name.not_applied" />, value: "" },
            { label: <FormattedMessage id="order.status.in_progress_label" />, value: "", disabled: true },
            ...orderedOptions,
            { label: <FormattedMessage id="order.status.completed_label" />, value: "", disabled: true },
            ...completedOptions
        ]

        var newStatusId = ''
        if (trigger.attributes) {
            const id = trigger.attributes.config.newStatusId
            if (statusesMap[id]) { // else it was deleted 
                newStatusId = id
            }
        }

        const html = [
            <div className="row">
                <div className="col-12 d-flex justify-content-between align-items-center">

                    <span>
                        {this.props.intl.formatMessage(messages[key])}
                        <FormattedMessage
                            id="triggers.command_type.change_order_status_command"
                        />
                    </span>

                    <span className="pl-2 w-25">
                        <Select
                            disabled={!this.state.loading}
                            clearable={false}
                            options={options}
                            value={newStatusId}
                            onChange={this.onSelectChange(key)}
                        />
                    </span>

                </div>
            </div>
        ]

        return {
            rowId: key,
            data: html
        }
    }

    render() {

        return (
            <div>

                <h3 className={'mt-3'}>
                    <span className={'badge bg-secondary text-white'}>
                        <FormattedMessage
                            id="triggers.trigger_title"
                        />
                    </span>
                </h3>

                <StandardList
                    className="row pt-3"
                    rows={this.state.triggersHtml.concat({
                        rowId: triggerKeys.orderStatusNotificationTrigger,
                        data: [<EmailNotificationAutomationComponent
                            statuses={this.props.orderStatuses}
                            triggerable={this.state.triggersOrdUpdate[triggerKeys.orderStatusNotificationTrigger]}
                            onSave={() => {
                                //refetch the triggerables to rerender
                                this.fetchTriggers()
                            }} />]
                    })}
                    smallLine={true}
                    tableContainerStyle={{ overflow: 'visible' }}
                />
            </div>
        );
    }
}

export default injectIntl(OrderStatusTriggersList)



// WEBPACK FOOTER //
// ./src/order-status/orderStatusTriggersList.component.jsx